export default "__VITE_ASSET__II1g5GRC__"